import { render, staticRenderFns } from "./novelconfig.vue?vue&type=template&id=85c3af8c"
import script from "./novelconfig.vue?vue&type=script&lang=js"
export * from "./novelconfig.vue?vue&type=script&lang=js"
import style0 from "./novelconfig.vue?vue&type=style&index=0&id=85c3af8c&prod&lang=css"
import style1 from "./novelconfig.vue?vue&type=style&index=1&id=85c3af8c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports